export default class SelectStyles {

	constructor() {

	    $('.select2').select2();
	    
	    $('.select2--taggable').select2({
			tags: true
		});

		$('.select2--no-search').select2({
			minimumResultsForSearch: Infinity
		});

		$('.select2--search').each(function() {

			var url = $(this).attr('data-search');

			$(this).select2({
				ajax: {
					url: url,
					dataType: 'json',
					delay: 300,
					processResults: function (response) {
						return {
							  results: response
						};
					},
					cache: true
				},
				placeholder: {
					id: "",
					placeholder: "Search..."
				},
				minimumInputLength: 2,
			    allowClear: true
			});

		});

		$(document).on('focus', '.select2.select2-container', function (e) {
			// only open on original attempt - close focus event should not fire open
			if (e.originalEvent && $(this).find(".select2-selection--single").length > 0) {
				$(this).siblings('select').select2('open');
			} 
		});

	}

}